import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { map, take, pick, filter, forEach, keys, concat, contains } from 'ramda';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';
import { formatDate } from 'lib/dateDisplay';

import { path } from 'routes/Documents/routes/Scores';
import calculateFSS from 'routes/Documents/routes/Scores/calculateFSS';
import calculateMSISTotals from 'routes/Documents/routes/Scores/calculateMSIS';
import calculateMSNQTotals from 'routes/Documents/routes/Scores/calculateMSNQ';
import calculateFSMCTotals from 'routes/Documents/routes/Scores/calculateFSMC';
import calculateSDMTTotals from 'routes/Documents/routes/Scores/calculateSDMT';
import fatigueSections from 'routes/Documents/routes/Scores/FSSSections';

import icon from '../assets/fatigue.svg';

const whitelistFatigue = pick(fatigueSections);

const scoreNames = {
  msis: 'MSIS-29',
  fss: 'FSS',
  sdmt: 'SDMT',
  msnq: 'MSNQ',
  fsmc: 'FSMC',
};

const pickRecent = d => {
  let docs = [];
  let amount = 5;
  forEach(key => {
    let keyData = take(amount, filter(pred(key), d));
    if (key === 'msis') keyData = calculateMSISTotals(keyData);
    if (key === 'fsmc') keyData = calculateFSMCTotals(keyData);
    if (key === 'msnq') keyData = calculateMSNQTotals(keyData);
    if (key === 'sdmt') keyData = calculateSDMTTotals(keyData);
    docs = concat(docs, keyData);
  }, keys(scoreNames));
  return take(
    5,
    docs.sort((a, b) => {
      return b.createDate - a.createDate;
    }),
  );
};

const pred = key => d => d.documentType === key;

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    {map(d => (
      <TileRow key={d.documentId} title={formatDate(d.createDate)}>
        <p className="bold">
          {scoreNames[d.documentType] + ': '}
          {contains(d.documentType, ['msis', 'fsmc']) &&
            `${d.scores.physical + d.scores.mental} (${d.scores.physical} + ${d.scores.mental})`}
          {d.documentType === 'fss' && calculateFSS(whitelistFatigue(d))}
          {d.documentType === 'msnq' && `${d.score}`}
          {d.documentType === 'sdmt' && `${d.score} / ${d.filled}`}
        </p>
      </TileRow>
    ))(pickRecent(data))}
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, {
  module: ['msis', 'fss', 'sdmt', 'msnq', 'fsmc'],
  localeId: 'scores.title',
  routeTo: path,
  icon,
});
